// The blocking category is named 'Offensive Line' or 'Blocking' depending on
// which amf-common version the API is running.
// TODO: remove once amf-common rename is fully deployed.
export const BLOCKING_CATEGORY_ALIASES = ['Blocking', 'Offensive Line'];

// map the selected positions to the allowed stat category tabs.
// Both 'Blocking' and 'Offensive Line' are listed so the tab is shown
// regardless of which name the API currently returns.
// TODO: remove 'Offensive Line' entries once amf-common rename is fully deployed.
export const STAT_CATEGORY_TABS = {
  OFFENSIVE_LINEMAN: ['Blocking', 'Offensive Line', 'Physical'],
  QUARTERBACK: ['Passing', 'Rushing', 'Physical'],
  RUNNING_BACK: [
    'Rushing',
    'Receiving',
    'Blocking',
    'Offensive Line',
    'Physical',
  ],
  WIDE_RECEIVER: ['Receiving', 'Rushing', 'Physical'],
  TIGHT_END: ['Receiving', 'Rushing', 'Blocking', 'Offensive Line', 'Physical'],
  DEFENSIVE_LINEMAN: ['Defensive Line', 'Physical'],
  LINEBACKER: ['Linebackers', 'Physical'],
  DEFENSIVE_BACK: ['Defensive Backs', 'Physical'],
  PUNTER: ['Special Teams'],
  HOLDER: ['Special Teams'],
  KICKER: ['Special Teams'],
  LONG_SNAPPER: ['Special Teams'],
  KICK_RETURNER: ['Special Teams'],
  PUNT_RETURNER: ['Special Teams'],
};

// map the selected positions to the allowed stat category tabs
export const STAT_SUB_CATEGORY_TABS = {
  OFFENSIVE_LINEMAN: {
    Physical: ['Primary', 'OL Pass Pro Dist'],
  },
  QUARTERBACK: {
    Bio: ['Bio'],
    Passing: ['Primary', 'Contextual', 'Pocket', 'Secondary'],
    Physical: ['Primary'],
    Rushing: ['Primary', 'Contextual'],
  },
  RUNNING_BACK: {
    Physical: [
      'Primary',
      'RB Breakaway Speed',
      'RB LOS Acceleration',
      'WR Get Off',
    ],
  },
  WIDE_RECEIVER: {
    Physical: [
      'Primary',
      'Deep Route Speed',
      'RB Breakaway Speed',
      'RB LOS Acceleration',
      'WR Get Off',
    ],
  },
  TIGHT_END: {
    Physical: [
      'Primary',
      'Deep Route Speed',
      'RB Breakaway Speed',
      'RB LOS Acceleration',
      'WR Get Off',
    ],
  },
  DEFENSIVE_LINEMAN: {
    Physical: ['Primary', 'DL Get Off'],
  },
  LINEBACKER: {
    Physical: ['Primary'],
  },
  DEFENSIVE_BACK: {
    Physical: ['Primary', 'Closing Speed'],
  },
  PUNTER: {
    'Special Teams': ['Punting', 'ST Tackling'],
  },
  HOLDER: {
    'Special Teams': ['FG/XP', 'ST Tackling'],
  },
  KICKER: {
    'Special Teams': ['FG/XP', 'Kickoffs', 'ST Tackling'],
  },
  LONG_SNAPPER: {
    'Special Teams': ['Long Snappers', 'ST Tackling'],
  },
  KICK_RETURNER: {
    'Special Teams': ['Kick Returns', 'ST Tackling'],
  },
  PUNT_RETURNER: {
    'Special Teams': ['Punt Returns', 'ST Tackling'],
  },
};
